import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  private selects: NodeListOf<HTMLSelectElement>

  connect() {
    this.selects = document.querySelectorAll(
      'select[name$="election[country_code]"]'
    )

    this.selects.forEach(select =>
      select.addEventListener("change", this.handleChange)
    )
  }

  disconnect() {
    this.selects.forEach(select =>
      select.removeEventListener("change", this.handleChange)
    )
  }

  private handleChange = (event: Event) => {
    const origin = event.target as HTMLSelectElement
    const newValue = origin.value
    this.selects.forEach(select => {
      if (select !== origin) select.value = newValue
    })
  }
}
